export const BLUEFRUIT = {
  SERVICE_UUID: "6e400001-b5a3-f393-e0a9-e50e24dcca9e",
  TX_CHARACTERISTIC_UUID: "6e400002-b5a3-f393-e0a9-e50e24dcca9e",
  RX_CHARACTERISTIC_UUID: "6e400003-b5a3-f393-e0a9-e50e24dcca9e",
};

export const DSD_TECH = {
  SERVICE_UUID: 0xffe0,
  TX_CHARACTERISTIC_UUID: 0xffe1,
  RX_CHARACTERISTIC_UUID: 0xffe1,
};

export const SUPREME_DUCK = {
  SERVICE_UUID: 0xffe0,
  TX_CHARACTERISTIC_UUID: 0xffe1,
  RX_CHARACTERISTIC_UUID: 0xffe0,
};
